import { gql } from '@apollo/client';

export const GET_AVAILABLE_COMPETITIONS = gql`
  query GetAvailableCompetitions {
    getAvailableCompetitions {
      id
      code
      displayName
      rank
      autonomousCommunity {
        id
        name
        flagUrl
      }
      officialChannels {
        id
        name
        image
        updatedAt
      }
    }
  }
`;
